import { IParamsData, ILines, IResponseInit, EventConstantsLeander, PlatformConstantsLeander } from "@quest/oddsworks-platform/dist";
import { EventConstants as PlatformEventConstants } from "@quest/platform-core";
import { ingenuity, dispatcher, IEvent, clone } from "@quest/base-core";
import { Parser, EventConstants } from "@quest/platform-murka/dist";
import { SlotEventConstants } from "@quest/slot-core";

import { GameParserModel } from "./GameParserModel";
import { gameConstants } from "../Constants/gameConstants";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { PlatformConstantsGame } from "../Constants/PlatformConstantsGame";

export class GameParser extends Parser {
  protected model: GameParserModel;

  // Override to add game end events
  protected bindEvent(): void {
    super.bindEvent();
    dispatcher.on(eventDispatchers.PARSE_FREE_GAME_RESPONSE_AFTER_REQUEST, this.parseFreeGameResponseAfterRequest, this);
    dispatcher.on(eventDispatchers.HANDLE_FLOWERS_ON_BET_CHANGE, this.handleFlowersInBetChange, this);
    dispatcher.on(eventDispatchers.STORE_GRID_WITH_BET, this.storeGridWithBet, this);
  }
  /**
    * Methor overrided to reset freegame broken data if not reset before broken
    */
  protected parseInitResponse(response: IResponseInit): void {
    this.processInitialConfigs(response);
    this.processBalance(response);
    // change order to handal broken persing//
    this.processGameParameters(response.params);
    if (response.params.responseHistory) {
      dispatcher.fireEvent(EventConstantsLeander.GAME_STATUS_UPDATED, PlatformConstantsLeander.OPEN_PLAY);
      this.processBrokenGameData(response.data);
    }
    else if (response.data.brokenData && response.data.brokenData.data.CurrentCount > 0) {
      dispatcher.fireEvent(EventConstantsLeander.SAVE_DATA_REQUEST, this.model.getUserGameCloseData());
    }
    this.openGameProcessed();
  }
  // Overrided to send init wrapper call after initialize broken game TODO: add in behavior
  protected openGameProcessed(): void {
    if (ingenuity.configData.isBrokenGame) {
      this.model.getFreeGameBroken() && this.parseBrokenFreeGameData();
      dispatcher.fireEvent(EventConstants.INITIATE_BROKEN_GAME);
      dispatcher.fireEvent(EventConstants.ERROR_FOR_BROKEN);
    } else {
      dispatcher.fireEvent(PlatformEventConstants.OPEN_GAME_PROCESSED);
    }
    dispatcher.fireEvent(EventConstantsLeander.SEND_INIT_WRAPPER);
  }
  // Override to convert initial reel grid in 8X5
  protected processGameParameters(params: any) {
    super.processGameParameters(params);
    this.model.setCurrentBetIndex(this.model.getBetPerLine().indexOf(this.model.getCurrentBet()));
    params.WildMeterInfo && this.model.setFlowerCollectMeterData(params.WildMeterInfo);
    params.PreGridInfo && this.model.setGridForAllBet(params.PreGridInfo);
    params.WildMeterInfo && this.parseFlowerCollectMeterData(params.WildMeterInfo)
    params.PreWildMeterInfo && this.model.setPreFlowerCollectMeterData(params.PreWildMeterInfo)
    params.PreWildMeterInfo && this.parsePreviousFlowerMeterData(params.PreWildMeterInfo);
    this.updatePreGridOnRefresh()
    if (!ingenuity.configData.isBrokenGame) {
      this.model.setReelGrid(this.updateGridWithDisableOnion(clone(this.model.getReelGrid())));
    }
    this.model.setMaxGameRTP(params.maxRTP);
    this.model.setMinGameRTP(params.minRTP);


  }
  /**
 * function is created to prevent showing NoPrizeReelLayout in case of last wild
 */
  private updatePreGridOnRefresh(): void {
    const grid = (this.model.getGridForAllBet() && this.model.getGridForAllBet()[this.model.getCurrentTotalBet()]) ? this.model.getGridForAllBet()[this.model.getCurrentTotalBet()].reelLayout : this.model.getNoPrizeReelLayout();
    this.model.setReelGrid(this.updateReelGrid(grid))
  }
  // Override to convert reel grid in 8X5
  protected processParameters(params: IParamsData): void {
    this.resetFlowerCollectData();
    super.processParameters(params);
    this.checkAndUpdateWildReelGrid();
    if (ingenuity.configData.isBrokenGame) {
      this.model.setTriggerReelGrid(this.updateBrokenGridWithOnion(clone(this.model.getReelGrid())));
    }
    this.checkForStackSymInReelGrid();
    this.model.setGameWinAmt(this.model.getBaseGameWinAmt());
  }
  private updateBrokenGridWithOnion(grid: number[][]): number[][] {
    if (grid.length && this.model.getFreeGameBroken()) {
      for (let i = 0; i < grid.length; i++) {
        for (let j = 0; j < grid[i].length; j++) {
          if (grid[i][j] === gameConstants.SPECIAL_SYM_NUM) {
            grid[i][j] = gameConstants.SPECIAL_DISABLE_SYM_NUM;
          }
        }
      }
    }
    return grid
  }
  /**
   * to parse correct triggering grid for onion disable symbol
   */
	protected processFreeGameBrokenData(brokenData: any) {
    if (brokenData.brokenInFg) {
      super.processFreeGameBrokenData(brokenData);
      if (ingenuity.configData.isBrokenGame) {
        this.model.setTriggerReelGrid(this.updateBrokenGridWithOnion(clone(this.model.getReelGrid())));
      }
    }
	}
  //check if stack is present in reelgrid
  private checkForStackSymInReelGrid(): void {
    const reelGrid: number[][] = this.model.getReelGrid();
    let stackSymoffset: number[][] = [];
    let numberOfSingleStackSymbol: number = 0;
    for (let i: number = 0; i < reelGrid.length; i++) {
      numberOfSingleStackSymbol = 0;
      for (let j: number = 0; j < reelGrid[i].length; j++) {
        if (reelGrid[i][j] === 1) {
          numberOfSingleStackSymbol++;
          const pos: number[] = [i, j];
          stackSymoffset.push(pos);
          if (numberOfSingleStackSymbol > 1) {
            this.model.setStackSymPresent(true);
          }
        }
        else {
          if (stackSymoffset.length != 0 && numberOfSingleStackSymbol >= 1) {
            break;
          }
        }
      }
    }
    this.model.setStackSymOffsets(stackSymoffset);
  }
  /**
   * to update reel grid in case of wild trigger scenario
   */
  private checkAndUpdateWildReelGrid(): void {
    if (this.model.getWildOnReel().length && this.model.getPreWildGrid().length) {
      let udpatePreGrid: number[][];
      if (ingenuity.configData.isBrokenGame) {
        udpatePreGrid = this.handleBrokenGridOnMultipleWild();
      } else {
        udpatePreGrid = this.model.getPreWildGrid();
      }
      this.model.setReelGrid(udpatePreGrid);
    }
  }
  /**
   * to update reel grid to handle slow network issue in case of wild present
   */
  private handleBrokenGridOnMultipleWild(): number[][] {
    let updatedGrid: number[][] = [];
    let currentGrid = clone(this.model.getReelGrid());
    currentGrid.forEach((reel: number[], index: number) => {
      if (!this.model.getPreWildPresentOnReel()[index]) {
        updatedGrid[index] = this.model.getPreWildGrid()[index]
      } else {
        updatedGrid[index] = reel
      }
    })
    return updatedGrid

  }
  /**
   * oveerrided to work for selection screen
   */
  protected parseFreeSpin(response: any): void {
    this.model.setPickChoice(null);
    super.parseFreeSpin(response);
    this.model.setPickChoice(response.pickChoice)
    this.model.setIsFreeSpintriggered(true);
    this.checkForStackSymInReelGridFG();
  }
  // Parse free game response during broken
  protected checkAndStoreBrokenData(data: any) {
    ingenuity.configData.isBrokenGame = true;
    data.length &&
      data.forEach((response: any) => {
        if (response.method === "getBetResult" && response.params[0].bonusInfo[0].bonusName === "BonusFreeSpins") {
          ingenuity.configData.selectionScreenResponse = true;
          this.parseFreeSpin(response.params[0].bonusInfo[0]);
        } else if (response.method === "getBetResult") {
          this.processParameters(response.params[0]);
        } else if (response.method === "placeBet" && response.bet > 0) {
          this.processPlaceBetData(response);
          this.model.setPlayID(response.playId);
          this.model.setSessionId(response.sessionId);
          this.model.setCurrentTotalBet(response.bet);
        }
      });
  }
  // Override to update reel set value based on monkey symbol
  protected processReelsData(reelsData: any): void {
    this.model.setBaseReel(this.changeSymNumber(reelsData[PlatformConstantsGame.BASE_GAME_REELSET]));
    this.model.setFreeSpinReel(this.changeSymNumber(reelsData[PlatformConstantsGame.FREE_GAME_REELSET]));
  }
  /**
   * override to change 200 symbol number into 11 , and 101 into 12
   */
  protected updateReelGrid(grid: number[]): number[][] {
    let updatedSymbolGrid: number[] = this.changeSymNumber(grid);
    return super.updateReelGrid(updatedSymbolGrid);
  }
  /**
   * function will convert symbol number 200 into 11, 101 into 12 111 into 13
   */
  private changeSymNumber(grid: number[] | number[][]): any {
    let changeSymbolNo = (index: number, elementId: number, elementArr: any) => {
      if (elementId === 110) {
        elementArr[index] = gameConstants.SCATTER_SYM_NUM;
      }
    }
    grid.forEach((element: any, index: number) => {
      if (Array.isArray(element)) {
        element.forEach((position: number, index: number) => {
          changeSymbolNo(index, position, element);
        });
      } else {
        changeSymbolNo(index, element, grid);
      }
    });
    return grid;
  }
  /**
   * overrided to add basegame win amount
   */
  public processWinningLines(winningLinesData: any) {
    super.processWinningLines(winningLinesData);
    this.model.setBaseGameWinAmt(winningLinesData.creditsWon);
  }
  // Override to update win lines offset position based on 8X5 grid
  protected processLinesData(data: ILines[]): void {
    this.model.setLinesWinUniquePositions([]);
    this.model.setWinLinesData(this.model.getWinLinesData());
    super.processLinesData(data);
  }
  /**
   *  iovuerrided to reset ffeatrue data on error
   */
  protected processGameAfterError(): void {
    this.resetFlowerCollectData();
    this.model.setNoSettleOnError(true);
    this.model.setBalance(this.model.getUserBalance());
    this.model.setFreeBalance(this.model.getUserBalance());

      if( this.model.getTotalBet()<=this.model.getBalance()){
dispatcher.fireEvent(EventConstants.UPDATE_CREDIT_VALUE, { value: this.model.getBalance() });
    }
   
    this.model.setReelGrid(this.updateReelGrid(this.model.getNoPrizeReelLayout()));
    dispatcher.fireEvent(PlatformEventConstants.SPIN_RESPONSE_PROCESSED);
  }
  /**
   * overrided to parse feature data
   */
  protected processBonusInfo(response?: any[]) {
    super.processBonusInfo(response);
    response.length &&
      response.forEach((data: any) => {
        if (data.bonusName === ingenuity.configData.TriggerBonusRound) {
          this.processTriggerScatterWin(data.scatter_offsets);
          this.parseSelectionScreenData(data);
          this.parseStickyWildPositions(data);
        }
        else if (data.bonusName === ingenuity.configData.WildMeterInfo) {
          this.model.setFlowerCollectMeterData(data.wildmeterDetails);
          this.parseFlowerCollectMeterData(data.wildmeterDetails)
          data.pregrid && this.model.setPreWildGrid(this.updateReelGrid(data.pregrid));
          this.parsePreviousFlowerMeterData(this.model.getPreFlowerCollectMeterData()) // added here bcz previous data is coming before current
        }
        else if (data.bonusName === ingenuity.configData.MeterInFo) {
          this.model.setPreFlowerCollectMeterData(data.preMeterdetails);
        }
        else if (data.bonusName === ingenuity.configData.GetSpecialCoins) {
          this.model.setOnionOffset(this.getGridToOffset(data.coinPos));
        }
        else if (data.bonusName === ingenuity.configData.PreGridInfo) {
          this.model.setGridForAllBet(data.meterDetails);
        }
      });
  }
  /**
   * overrided to manipulate scatter triggering data according to game
   */
  protected processTriggerScatterWin(data: any) {
    this.model.getTriggerScatterWinData().length = 0;
    const winScatter = {
      id: 0,
      no: gameConstants.SCATTER_SYM_NUM,
      win: 0,
      positions: this.getGridToOffset(data),
      winSymLen: data.length,
    };
    this.model.setTriggerScatterWinData([winScatter]);
    this.model.getTriggerScatterWinData.length > 0 && this.model.setHasScatterWins(true);
  }
  /**
   * function to parser selection screen data
   */
  private parseSelectionScreenData(data: any): void {
    if (data.pickableitems.length) {
      this.model.setSelectionScreenAvailable(true);
      let freeSpins: number[] = [];
      data.pickableitems.forEach((value: any) => {
        freeSpins.push(value.freespins);
      }, this);
      this.model.setAllSelectionfreeSpins(freeSpins);
    }
  }
  /**
   * to parse sticky feature data
   */
  private parseStickyWildPositions(data: any): void {
    if (data.pickableitems.length) {
      this.model.setIsStickyWildAvailable(true);
      let wildLock: number[][] = [];
      data.pickableitems.forEach((value: any) => {
        wildLock.push(value.wildlocked);
      }, this);
      this.model.setWildLockPos(wildLock);
    }
  }
  /**
   * to pass bet change related data
   */
  private handleFlowersInBetChange(): void {
    this.parseFlowerCollectMeterData(this.model.getFlowerCollectMeterData());
    this.parsePreviousFlowerMeterData(this.model.getPreFlowerCollectMeterData());
    this.storeGridWithBet()
  }
  /**
   * to store all grids as per bet
   */
  private storeGridWithBet(): void {
    const grid = (this.model.getGridForAllBet() && this.model.getGridForAllBet()[this.model.getCurrentTotalBet()]) ? this.model.getGridForAllBet()[this.model.getCurrentTotalBet()].reelLayout : this.model.getNoPrizeReelLayout()
    this.model.setCurrentBetGrid(this.updateReelGrid(grid))
  }
  /**
 * function will parse data related to wild feature
 */
  private parseFlowerCollectMeterData(data: any): void {
    let wildArray: number[] = [];
    let wildPresentArray: boolean[] = [];
    let reelCountArray: number[] = [0, 0, 0, 0, 0];
    let totalSpaceArray: number[] = [3, 4, 5, 4, 3];
    let response: any;
    if (data) {
      response = data[this.model.getCurrentTotalBet()];
    }
    response && Object.entries(response).forEach((value: any, index: number) => {
      if (value[1].expendingwild) {
        wildArray.push(index);
      }
      wildPresentArray[index] = (value[1].expendingwild);
      reelCountArray[index] = (value[1].counter);
      totalSpaceArray[index] = (value[1].fixedmeterlen);
    })
    this.model.setWildOnReel(wildArray);
    this.model.setIsWildPresentOnReel(wildPresentArray);// stores true and false
    this.model.setCollectedFlowers(reelCountArray);
    this.model.setTotalFlowerSpace(totalSpaceArray);
  }
  /**
   * function will parse feature data of previous spin
   */
  private parsePreviousFlowerMeterData(data: any): void {
    let prePresentWildArray: boolean[] = [];
    let preWildArrayOnReel: number[] = [];
    let preReelCountArray: number[] = [0, 0, 0, 0, 0];
    let response: any;
    if (data) {
      response = data[this.model.getCurrentTotalBet()];
    }
    response && Object.entries(response).forEach((value: any, index: number) => {
      if (value[1].expendingwild) {
        preWildArrayOnReel.push(index);
      }
      prePresentWildArray[index] = (value[1].expendingwild);
      preReelCountArray[index] = (value[1].counter);
    })
    this.model.setPreWildOnReel(preWildArrayOnReel);
    this.model.setPreWildPresentOnReel(prePresentWildArray);// stores true and false
    this.model.setPreCollectedFlowers(preReelCountArray);
    this.handleFlowerFeatureInBroken();
    this.handleLastWild();
  }
  /**
   * funciton will handle feature data on broken
   */
  private handleFlowerFeatureInBroken(): void {
    let brokenFlowerCount: number[] = []
    let brokenWild: number[] = []
    for (let i = 0; i < ingenuity.configData.numberOfReel; i++) {
      if ((this.model.getPreWildPresentOnReel()[i])) {
        brokenFlowerCount[i] = this.model.getCollectedFlowers()[i];
        brokenWild.push(i)
      } else {
        brokenFlowerCount[i] = this.model.getPreCollectedFlowers()[i];
      }
    }
    this.model.setPreWildOnReel(brokenWild);
    this.model.setPreCollectedFlowers(brokenFlowerCount);
  }
  /**
   * to handle data related to last wild as we have to manage it bcz in data its already gone for that spin
   */
  private handleLastWild(): void {
    let storeLastWildReelID = [];
    for (let i = 0; i < ingenuity.configData.numberOfReel; i++) {
      if (this.model.getPreWildPresentOnReel()[i] && this.model.getCollectedFlowers()[i] === 0) {
        storeLastWildReelID.push(i);
      }
    }
    ingenuity.configData.checkForLastFlower = storeLastWildReelID;
  }

  /**
   * function to reset flower collection data 
  */
  private resetFlowerCollectData(): void {
    // this.model.setFlowerCollectMeterData(null);
    this.model.setOnionOffset([]);
    this.model.setWildOnReel([]);
    this.model.setCollectedFlowers([]);
    this.model.setTotalFlowerSpace([]);
    this.model.setPreWildGrid([]);
    this.model.setCurrentBetGrid([]);
    this.model.setGridForAllBet(null);
    this.model.setPreWildPresentOnReel([]);
    this.model.setPreCollectedFlowers([]);
  }
  // Parse free game response
  private parseFreeGameResponseAfterRequest(evt: IEvent): void {
    ingenuity.configData.selectionScreenResponse = true;
    this.parseFreeSpin(evt.data.params[0].bonusInfo[0]);
    this.model.setTotalWin(evt.data.params[0].creditsWon);
    ingenuity.configData.isSelectionComplete && dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);

  }

  // Overrided to reset selection screen data
  protected parseNextFreeSpinData(evt?: IEvent): void {
    super.parseNextFreeSpinData(evt);
    this.model.setSelectionScreenAvailable(false);
    this.checkForStackSymInReelGridFG();
  }

  // Overrided to reset selection screen data
  protected parseBrokenFreeGameData(): void {
    super.parseBrokenFreeGameData();
    this.model.setSelectionScreenAvailable(false);
    this.checkForStackSymInReelGridFG();
  }
  //check if stack is present in reelgrid
  private checkForStackSymInReelGridFG(): void {
    const reelGrid = this.model.getReelGrid();
    let stackSymoffsetFG: number[][] = [];
    let numberOfSingleStackSymbol: number = 0;
    for (let i: number = 0; i < reelGrid.length; i++) {
      numberOfSingleStackSymbol = 0;
      for (let j: number = 0; j < reelGrid[i].length; j++) {
        if (reelGrid[i][j] === 1) {
          numberOfSingleStackSymbol++;
          const pos: number[] = [i, j];
          stackSymoffsetFG.push(pos);
          if (numberOfSingleStackSymbol > 1) {
            this.model.setStackSymPresentFG(true);
          }
        }
        else {
          if (stackSymoffsetFG.length != 0 && numberOfSingleStackSymbol >= 1) {
            break;
          }
        }
      }

    }
    this.model.setStackSymOffsetsFG(stackSymoffsetFG);
  }
  /**
   * function will update triggering grid with the disabled onion , 
   * as onions will be disabled at the tim eof freegame return
   */
  private updateGridWithDisableOnion(grid: number[][]): number[][] {
    if (grid.length) {
      for (let i = 0; i < grid.length; i++) {
        for (let j = 0; j < grid[i].length; j++) {
          if (grid[i][j] === gameConstants.SPECIAL_SYM_NUM) {
            grid[i][j] = gameConstants.SPECIAL_DISABLE_SYM_NUM;
          }
        }
      }
    }
    return grid
  }

  protected processGetBetResult(betResultData: any) {
    betResultData.balance >= 0 && this.model.setBalance(betResultData.balance);
    betResultData.freeBalance >= 0 && this.model.setFreeBalance(betResultData.freeBalance);
    this.model.setFreePlaysData(betResultData.freePlaysData);
    betResultData.params && this.processParameters(betResultData.params[0]);
    this.model.setIsPlayingFreePlay(betResultData.playingFreePlay);
    dispatcher.fireEvent(EventConstants.UPDATE_CREDIT_VALUE);
  }
}
